<template>
  <b-form-group
    :label="label"
    label-for="zones"
  >
    <v-select
      id="zones"
      label="name"
      :options="zones"
      :loading="loadingZones"
      :clearable="clearable"
      :placeholder="placeholder"
      @input="onZoneSelected"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import { computed, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import useZoneList from '@/views/zones/useZoneList'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import zonesStore from '@/views/zones/zoneStoreModule'

export default {
  components: {
    BFormGroup,
    vSelect,
  },
  props: {
    label: {
      type: String,
      default: 'Zones',
    },
    placeholder: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  setup(_, ctx) {
    useRegisterStoreModule('zones', zonesStore)

    const { tableData: fetchedZones, loadingZones, ...rest } = useZoneList()
    const zones = computed(() => {
      let temp = []
      temp = fetchedZones.value?.filter(el => el.area === 'None')
      return temp
    })

    const onZoneSelected = event => {
      if (!event) {
        ctx.emit('zone-selected', null)
        return
      }

      ctx.emit('zone-selected', `${event.country}::${event.city}`)
    }
    watch(loadingZones, () => {
      ctx.emit('zones-loading-state', loadingZones.value)
    }, { immediate: true })

    return {
      loadingZones,
      ...rest,
      zones,
      onZoneSelected,
    }
  },
}
</script>

  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  </style>

  <style lang="scss">
  </style>
